import { render, staticRenderFns } from "./PageFormat.vue?vue&type=template&id=7f65dd66&scoped=true&"
import script from "./PageFormat.vue?vue&type=script&lang=js&"
export * from "./PageFormat.vue?vue&type=script&lang=js&"
import style0 from "./PageFormat.vue?vue&type=style&index=0&id=7f65dd66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f65dd66",
  null
  
)

export default component.exports